var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEbay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.957,
    height: 10,
    viewBox: "0 0 24.957 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ebay",
    transform: "translate(-0.1 -0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6245",
    "data-name": "Path 6245",
    d: "M3.327,26.309c-1.76,0-3.227.747-3.227,3,0,1.785.986,2.909,3.273,2.909,2.691,0,2.864-1.773,2.864-1.773h-1.3a1.566,1.566,0,0,1-1.639.955,1.785,1.785,0,0,1-1.9-1.8H6.373v-.658c0-1.037-.658-2.636-3.045-2.636Zm-.046.841a1.61,1.61,0,0,1,1.773,1.614H1.418A1.724,1.724,0,0,1,3.282,27.15Z",
    transform: "translate(0 -24.027)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6246",
    "data-name": "Path 6246",
    d: "M75.127.1V7.059c0,.4-.028.95-.028.95h1.244s.045-.4.045-.762a2.661,2.661,0,0,0,2.285.961,2.824,2.824,0,0,0,2.954-2.971A2.808,2.808,0,0,0,78.675,2.3a2.519,2.519,0,0,0-2.275.937V.1Zm3.227,3.06a1.924,1.924,0,0,1,1.955,2.077,1.97,1.97,0,0,1-1.946,2.111,1.95,1.95,0,0,1-1.963-2.1A1.937,1.937,0,0,1,78.354,3.16Z",
    transform: "translate(-68.756)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6247",
    "data-name": "Path 6247",
    d: "M155.106,26.309c-2.648,0-2.818,1.45-2.818,1.682h1.318s.069-.847,1.409-.847c.871,0,1.545.4,1.545,1.165v.273h-1.545c-2.052,0-3.136.6-3.136,1.818,0,1.2,1,1.851,2.356,1.851a2.722,2.722,0,0,0,2.44-1.02c0,.406.031.805.031.805h1.172s-.045-.5-.045-.812v-2.74C157.833,26.687,156.384,26.309,155.106,26.309Zm1.454,3.091v.364c0,.474-.293,1.653-2.016,1.653-.943,0-1.348-.471-1.348-1.017C153.2,29.406,154.559,29.4,156.561,29.4Z",
    transform: "translate(-139.144 -24.027)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6248",
    "data-name": "Path 6248",
    d: "M214.879,29.041h1.483L218.49,33.3l2.123-4.264h1.343l-3.868,7.591H216.68l1.116-2.116-2.917-5.475Z",
    transform: "translate(-196.899 -26.532)",
    fill: "#fdfdfd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbay);
export default __webpack_public_path__ + "static/media/ebay.97f6e41d21b4854cbbac3cf09013405e.svg";
export { ForwardRef as ReactComponent };